import { Heading, SystemStyleObject } from "@chakra-ui/react"

export const SectionHeading = ({ children, sx, ...rest }: { children: React.ReactNode, sx?: SystemStyleObject }) => {
    return (
        <Heading sx={{ fontSize: 'xl', fontWeight: 'normal', mt: 1, mb: 2, ...sx }} {...rest}>{children}</Heading>
    )
}